import { createSlice } from "@reduxjs/toolkit";

export const thirdPartySlice = createSlice({
  name: "thirdParty",
  initialState: {
    truckDetails: [],
    verifiedPhone: [],
    updateTotalWeight: 0,
  },
  reducers: {
    updateTruckDetails: (state, action) => {
      const { index, fieldName, value } = action.payload;
      if (index >= 0 && index < state.truckDetails.length) {
        state.truckDetails[index].truckDetails[fieldName] = value;
      }
    },

    updateCommodityDetails: (state, action) => {
      const { index, fieldName, value } = action.payload;
      if (index >= 0 && index < state.truckDetails.length) {
        state.truckDetails[index].commodityDetails[fieldName] = value;
      }
    },

    deleteTruckDetails: (state, action) => {
      const { index } = action.payload;
      state.truckDetails.splice(index, 1);
    },

    addTruckDetails: (state, action) => {
      state.truckDetails.push(action.payload);
    },

    updateTotalWeightValue: (state, action) => {
      state.updateTotalWeight = action.payload;
    },

    resetTruckDetail: (state, action) => {
      state.truckDetails = action.payload;
    },

    replaceTruckDetails: (state, action) => {
      state.truckDetails = action.payload; // replace whole array
    },

    updateTruckAndCommodity: (state, action) => {
      const { index, value } = action.payload;
      if (index >= 0 && index < state.truckDetails.length) {
        state.truckDetails[index] = value; // replace whole object at index
      }
    },

    setVerifiedPhoneNumber: (state, action) => {
      state.verifiedPhone = action.payload;
    },

    resetThirdPartyState: (state) => {
      state.truckDetails = [];
      state.verifiedPhone = [];
      state.updateTotalWeight = 0;
    },
  },
});

export const {
  updateTruckDetails,
  updateCommodityDetails,
  deleteTruckDetails,
  resetTruckDetail,
  addTruckDetails,
  replaceTruckDetails,
  updateTruckAndCommodity,
  setVerifiedPhoneNumber,
  updateTotalWeightValue,
  resetThirdPartyState,
} = thirdPartySlice.actions;

export default thirdPartySlice.reducer;

// {
//   truckDetails: {
//     vehicleType: "",
//     vehicleTypeOthers: "",
//     engineNo: "",
//     driverNumber: "",
//     driverName: "",
//     isOtpVerifed: true,
//     truckno: "",
//     truckTracker: "",
//     idCardDoc: [],
//   },
//   commodityDetails: {
//     commodity: "",
//     variety: "",
//     noOfBags: "",
//     quantityWithdrawal: "",
//   },
// },
